export default [
    /*
    {
    id: "12401",
    name: "Alberta Health Services (AHS) - Tom Baker Cancer Centre",
},*/
{
    id: "12402",
    name: "Centre Hospitalier de l'Universite Laval (CHUL)",
}, ];